
import logo from '../assets/logo.png';
import '../assets/css/footer.css'
import { Link } from 'react-router-dom';


function Footer(){
    return(
        <>
            <footer className="footer">
                <div className='footer_container' >
                    <Link to={'/'}><img className="logo" src={logo}/></Link>
                    <p className='footer_derechos'>Copyright © 2023 <span style={{color:"var(--orange)"}}>M&Z</span> tapizados</p>
                    <p className='footer_derechos'>Powered by <a className="derechos-autor"href='https://tinchogithub.github.io/Portafolio-Martin-Perez/' target='_blank'>Martín Perez</a></p>
                </div>
            </footer>
        </>
    )
}

export default Footer;